import { Button, Container, Spacer, SvgArrowRight } from '@loomhq/lens';
import React from 'react';

import { LARGE_TABLET_MAX_WIDTH } from 'constants/breakpoints';

import MediaQuery from 'components/media-query';

import styles from './styles.module.less';

export const FixedMobileFooter = ({ children }) => {
  return (
    <MediaQuery query={`(max-width: ${LARGE_TABLET_MAX_WIDTH - 1}px)`}>
      <div
        className={`${styles.mobileFooter} bgc:white text:center fixed left:0 bottom:0 width:full p:medium`}
      >
        <Container paddingX={{ small: 16 }}>{children}</Container>
      </div>
    </MediaQuery>
  );
};

// cta customized for desktop and mobile
export const CustomizedCta = ({ children, isMobile }) => {
  if (isMobile) {
    return <FixedMobileFooter>{children}</FixedMobileFooter>;
  }

  return <div>{children}</div>;
};

export const DefaultCta = ({
  isMobile,
  onClick,
  isDisabled,
  loading = false,
}) => {
  const buttonProps = {
    size: 'large',
    hasFullWidth: isMobile,
    iconPosition: 'right',
    variant: 'primary',
    onClick,
    isDisabled,
    hasLoader: loading,
    icon: <SvgArrowRight />,
    type: 'submit',
  };

  if (isMobile) {
    return (
      <FixedMobileFooter>
        <Button {...buttonProps}>Continue</Button>
      </FixedMobileFooter>
    );
  }

  return (
    <Spacer top="xlarge">
      <Button {...buttonProps}>Continue</Button>
    </Spacer>
  );
};

// container to accomodate the fixed mobile cta
export const MobileScrollContainer = ({
  offset = '4.5rem',
  isMobile,
  children,
}) => {
  return (
    <Container
      height={isMobile ? `calc(100% - ${offset})` : 'auto'}
      className="overflow:visible"
    >
      {children}
    </Container>
  );
};
